/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Lembaga_D2dInputs */

const en_mk_sol_lembaga_d2d = /** @type {(inputs: Mk_Sol_Lembaga_D2dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every activity is recorded with a date and an owner, so the reporting material accumulates as you go.`)
};

const id_mk_sol_lembaga_d2d = /** @type {(inputs: Mk_Sol_Lembaga_D2dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setiap kegiatan tercatat dengan tanggal dan penanggung jawab, jadi bahan laporan terkumpul sepanjang jalan.`)
};

/**
* | output |
* | --- |
* | "Every activity is recorded with a date and an owner, so the reporting material accumulates as you go." |
*
* @param {Mk_Sol_Lembaga_D2dInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_lembaga_d2d = /** @type {((inputs?: Mk_Sol_Lembaga_D2dInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Lembaga_D2dInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_lembaga_d2d(inputs)
	return en_mk_sol_lembaga_d2d(inputs)
});